import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Card, Grid, Segment, Loader, Dropdown, Input, Button} from 'semantic-ui-react';
import {noTimeZoneShortISODate, dateFormatPicker} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {parseDealers} from '../../../common/util/options';
import {Actions} from '../../../common/actions';
import {ALL_AGENCIES} from '../../constants';
import './possDownload.scss';

const parseAgencies = (agencies, dealer = '') => {
  const filteredAgencies = agencies.filter((agency) => agency.dealerId === dealer).map(
    (agency, index) => ({'text': agency.description, 'value': agency.code, 'key': index}));

  const sortAgencies = filteredAgencies.sort((agency1, agency2) => {
    if (agency1.text === agency2.text) {
      return 0;
    }

    return agency1.text > agency2.text ? 1 : -1;
  });

  return [ALL_AGENCIES, ...sortAgencies];
};


class PossDownload extends Component {
  constructor(props) {
    super(props);
    const {isUserFromTDE, dealerId, dealerAgency} = props;
    this.state = {
      'dealer': isUserFromTDE ? '' : dealerId,
      'agency': isUserFromTDE ? '' : dealerAgency,
      'initialDate': moment().startOf('month'),
      'finalDate': moment(),
      'orderCode': '',
      'isUserDealerM': true,
    };

    this.handleParameterChange = this.handleParameterChange.bind(this);
    this.handleDealerChange = this.handleDealerChange.bind(this);
    this.handleInitialDateChange = this.handleInitialDateChange.bind(this);
    this.handleFinalDateChange = this.handleFinalDateChange.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DealerOrdersPossDownload, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    if (hasAccessPermission(this.props.permissions, resources.DealerOrdersPossDownload, scopes.LimitedSee)) {
      this.setState({
        'isUserDealerM': false,
      });
    }

    this.props.fetchDealers('importers');
    this.props.getAllAgencies();
  }

  handleParameterChange(event, data) {
    this.setState({[data.name]: data.value.toUpperCase()});
  }

  handleDealerChange(event, data) {
    this.setState({
      'agency': '',
      [data.name]: data.value,
    });
  }

  handleInitialDateChange(value) {
    const {finalDate} = this.state;

    this.setState({
      'initialDate': value,
      'finalDate': finalDate <= value ? value : finalDate,
    });
  }
  
  handleFinalDateChange(value) {
    this.setState({'finalDate': value});
  }

  handleClearClick() {
    const {isUserFromTDE, dealerId, dealerAgency, isUserDealerM} = this.props;

    this.setState({
      'dealer': isUserFromTDE ? '' : dealerId,
      'agency': isUserFromTDE || isUserDealerM ? '' : dealerAgency,
      'initialDate': moment().startOf('month'),
      'finalDate': moment(),
      'orderCode': '',
    });
  }

  handleDownloadClick() {
    const {dealerId} = this.props;
    const {dealer, agency, initialDate, finalDate, orderCode} = this.state;
    const error = this.props.isUserFromTDE ?
      'Es necesario especificar el concesionario, la agencia y el rango de fechas para la búsqueda' :
      'Es necesario especificar el rango de fechas para la búsqueda';

    if (!dealer || !agency || !initialDate || !finalDate) {
      this.props.addMessageBoxError(error);
      return;
    }

    this.props.downloadPossFile({
      dealer,
      agency,
      orderCode,
      'ruc': dealerId,
      'initialDate': moment(initialDate).format(noTimeZoneShortISODate),
      'finalDate': moment(finalDate).format(noTimeZoneShortISODate),
    });
  }

  renderDealerInfo() {
    const {isUserFromTDE, loading, agencies, dealers} = this.props;
    const {dealer, agency, isUserDealerM} = this.state;
    if (!isUserFromTDE && !isUserDealerM) {
      return null;
    }
    

    return (
      <Grid.Row textAlign='left' columns='3'>
        <Grid.Column>
          <label><strong>Concesionario</strong></label>
          <Dropdown fluid selection
            name='dealer'
            value={dealer}
            options={parseDealers(dealers)}
            disabled={loading || !isUserFromTDE || !isUserDealerM}
            onChange={this.handleDealerChange}
          />
        </Grid.Column>
        <Grid.Column>
          <label><strong>Agencia</strong></label>
          <Dropdown fluid selection
            name='agency'
            value={agency}
            options={parseAgencies(agencies, dealer) }
            disabled={loading || (!isUserFromTDE && !isUserDealerM)}
            onChange={this.handleParameterChange}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderLoader(downloading) {
    if (!downloading) {
      return null;
    }

    return (
      <Card raised fluid>
        <Loader active inline='centered'>Generando archivo...</Loader>
      </Card>
    );
  }

  render() {
    const {loading, downloading} = this.props;
    const {initialDate, finalDate, orderCode} = this.state;

    return (
      <div className='dealer-poss-download'>
        <Card raised fluid>
          <Grid>
            <Grid.Row>
              <Grid.Column width='10' textAlign='left'>
                <h2>Pedidos de Concesionarios - Descarga de POSS</h2>
              </Grid.Column>
              <Grid.Column width='6' textAlign='right'>
                <Button secondary onClick={this.handleClearClick}>
                  LIMPIAR
                </Button>
                <Button
                  primary
                  content='DESCARGAR'
                  disabled={loading || downloading}
                  onClick={this.handleDownloadClick}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Segment secondary>
                  <Grid>
                    <Grid.Row textAlign='left' columns='3'>
                      <Grid.Column>
                        <label>
                          <strong>Fecha inicial</strong>
                        </label>
                        <DatePicker
                          customInput={<Input fluid icon='calendar' />}
                          dateFormat={dateFormatPicker}
                          selected={moment(initialDate).toDate()}
                          onChange={this.handleInitialDateChange}
                          locale='es'
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <label>
                          <strong>Fecha final</strong>
                        </label>
                        <DatePicker
                          customInput={<Input fluid icon='calendar' />}
                          dateFormat={dateFormatPicker}
                          minDate={moment(initialDate).toDate()}
                          selected={moment(finalDate).toDate()}
                          onChange={this.handleFinalDateChange}
                          locale='es'
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <label>
                          <strong>Número de Pedido</strong>
                        </label>
                        <Input
                          fluid
                          name='orderCode'
                          maxLength='8'
                          value={orderCode}
                          onChange={this.handleParameterChange}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    {this.renderDealerInfo()}
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        {this.renderLoader(downloading)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
    'dealerAgency': state.session.dealerAgency,
    'permissions': state.session.permissions,
    'loading': state.dealer.loading || state.dealer.loadingAgencies,
    'dealers': state.dealer.list,
    'agencies': state.dealer.agencies,
    'downloading': state.possDownload.loading,
  };
};

const {
  fetchDealers,
  getAllAgencies,
  downloadPossFile,
  addMessageBoxError,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchDealers,
  getAllAgencies,
  downloadPossFile,
  addMessageBoxError,
  navigateTo,
})(PossDownload);
